<template>
  <div>
    <CrudList
      title="Información Adicional"
      storeName="Additional_info"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      next-link="/admin/verifications/edit/general"
      :breadcrumbs="[
        {
          text: 'Información y soporte',
          disabled: false,
          href: '/admin/additional_info'
        },
        {
          text: 'Información Adicional',
          disabled: false,
          href: '#'
        }
      ]"
    >
    <template v-slot:description="{item}">
      <v-container id="scroll-target"
                   style="max-height: 210px"
                   class="overflow-y-auto">
      <v-row v-scroll:#scroll-target="onScroll">
          <p> {{item.description}}</p>
      </v-row>
      </v-container>
    </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
